// extracted by mini-css-extract-plugin
export default {"allCategoriesContainer":"AllCategories_allCategoriesContainer__wKlZP","header":"AllCategories_header__3QG4m"};